'use strict';

var React = require('react'),
    BackColorMixin = require('../mixins/BackColorMixin'),
    Button = require('../atoms/Button'),
    UserActionCreators = require('../actions/UserActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    PropTypes = React.PropTypes;

var FollowUserButton = React.createClass({
  mixins: [BackColorMixin, PureRenderMixin],

  propTypes: {
    user: PropTypes.object.isRequired,
    size: PropTypes.oneOf(['medium', 'large']).isRequired
  },

  getDefaultProps: function () {
    return {
      size: 'medium'
    };
  },

  render: function () {
    var user = this.props.user;

    return (
      <Button color='green'
              onClick={this.handleFollowClick}
              active={user.isSubscribed}
              size={this.props.size}
              counter={user.subscriberCount}
              context={this.props.context}
              fill>
        {user.isSubscribed ?
          <span>Following</span> :
          <span>Follow</span>
        }
      </Button>
    );
  },

  handleFollowClick: function () {
    var user = this.props.user;

    if (user.isSubscribed) {
      UserActionCreators.unfollowUser(user.id);
    } else {
      UserActionCreators.followUser(user.id);
    }
  }
});

module.exports = FollowUserButton;



/** WEBPACK FOOTER **
 ** ./molecules/FollowUserButton.jsx
 **/